// extracted by mini-css-extract-plugin
export default {"menuButton":"menu_menuButton__LE+Ee","select":"menu_select__BStGe"};